import { z } from "zod";
import { Timestamps } from "../common/timestamps.schema.ts";
import { CustomerId } from "../fsm/fsm.schema.ts";
import { LocationId } from "../locations/locations.schema.ts";

export const UserId = z.string().uuid().brand<"UserId">();
export type UserId = z.infer<typeof UserId>;

export const UserLocationDto = z.object({
  userId: UserId,
  locationId: LocationId,
  customerId: CustomerId,
  createdAt: Timestamps.shape.createdAt,
});
export type UserLocationDto = z.infer<typeof UserLocationDto>;

export const GetUserLocationsInput = z.object({
  userId: UserId,
  customerId: CustomerId,
});
export type GetUserLocationsInput = z.infer<typeof GetUserLocationsInput>;

export const AssignUserLocationsInput = z.object({
  userId: UserId,
  customerId: CustomerId,
  locationIds: z.array(LocationId),
});
export type AssignUserLocationsInput = z.infer<typeof AssignUserLocationsInput>;
